// The nav package's requests (quick switcher, team sheet and team dialogs, category dialogs), sent
// from wherever the reader asked (sidebar menus, keyboard) to the ONE NavHost the workspace mounts —
// so the sidebar does not grow a dialog per action and the workspace a state per dialog.
import { useEffect } from 'react';

export type NavRequest =
  | { kind: 'switcher' }
  | { kind: 'teamSheet' }
  | { kind: 'teamMembers'; teamId: string }
  | { kind: 'teamAdd'; teamId: string }
  | { kind: 'teamsJoinable' }
  | { kind: 'teamLeave'; teamId: string }
  | { kind: 'categoryMenu'; teamId: string; categoryId: string; at: { x: number; y: number } }
  | { kind: 'categoryNew'; teamId: string; channelId: string | null }
  | { kind: 'categoryRename'; teamId: string; categoryId: string; name: string }
  | { kind: 'categoryDelete'; teamId: string; categoryId: string; name: string };

type Listener = (r: NavRequest) => void;
const listeners = new Set<Listener>();

export function openNav(request: NavRequest): void {
  for (const l of listeners) l(request);
}

export function useNavRequests(listener: Listener): void {
  useEffect(() => {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  }, [listener]);
}
